import { Box, Modal, Typography } from "@mui/material";
import { Warning as WarningIcon } from "@mui/icons-material";
import Button from "@accredo/fe-shared/theme/components/Button.jsx";
import { getEuro } from "@accredo/fe-shared/services/formatService.js";
import PropTypes from "prop-types";

const OverpaymentDialog = ({
  open,
  onClose,
  overpaymentAmount,
  onAssignWithRefund,
  onAssignWithoutRefund,
}) => {
  return (
    <Modal open={open} onClose={onClose}>
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: 480,
          bgcolor: "background.paper",
          boxShadow: 24,
          p: 4,
          borderRadius: 2,
        }}
      >
        <Box sx={{ display: "flex", alignItems: "center", gap: 1, mb: 2 }}>
          <WarningIcon color="warning" />
          <Typography variant="h6">Überzahlung erkannt</Typography>
        </Box>

        <Typography variant="body2" sx={{ mb: 2 }}>
          Die Summe der Zahlungseingänge übersteigt den Schadenbetrag um{" "}
          <strong>{getEuro(overpaymentAmount)}</strong>.
        </Typography>

        <Typography variant="body2" sx={{ mb: 3 }}>
          Soll automatisch eine Rückzahlung an den Versicherer über{" "}
          <strong>{getEuro(overpaymentAmount)}</strong> erstellt werden?
        </Typography>

        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            gap: 1.5,
          }}
        >
          <Button
            onClick={onAssignWithRefund}
            variant="primary"
            fullWidth
          >
            Zuordnen und Rückzahlung erstellen
          </Button>
          <Button
            onClick={onAssignWithoutRefund}
            variant="secondary"
            fullWidth
          >
            Nur zuordnen (ohne Rückzahlung)
          </Button>
          <Button onClick={onClose} variant="tertiary" fullWidth>
            Abbrechen
          </Button>
        </Box>
      </Box>
    </Modal>
  );
};

OverpaymentDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  overpaymentAmount: PropTypes.number.isRequired,
  onAssignWithRefund: PropTypes.func.isRequired,
  onAssignWithoutRefund: PropTypes.func.isRequired,
};

export default OverpaymentDialog;
